import React, { useRef, useState, useEffect } from "react";
import useInputCheckout from "../../hooks/useInputCheckout";
import ModalCheck from "./ModalCheck";
import baseUrl from "../../url/baseUrl";

import AOS from "aos";
import "aos/dist/aos.css";

const degree = 10440; // Base degree for spins

const Wheel = ({ onSpinResult }) => {
  const [isValid, setIsValid] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false); // Track if the wheel is spinning
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const innerWheelRef = useRef(null);

  useEffect(() => {
    // phần animation AOS
    AOS.init({
      offset: 0, // Offset (in px) from the original trigger point
      delay: 200, // Delay in milliseconds before animation starts.
      duration: 800, // Animation duration in milliseconds
      easing: "ease-in-sine", // Easing animation
      once: false, // Whether animation should happen only once
      mirror: false, // Whether the AOS should mirror elements when scrolling
    });

    // fix trường hợp user reload trang trước khi setTimeout thực thi +> vẫn Xóa shopName khỏi localstorage khi reload lại trang
    if (Date.now() > localStorage.getItem("shopNameExpiry")) {
      localStorage.removeItem("shopName");
      localStorage.removeItem("shopNameExpiry");
    } else {
      // Tính thời gian còn lại của shopName bằng miliseconds
      const shopNameRemaingTime =
        +localStorage.getItem("shopNameExpiry") - Date.now();
      // xóa shopName khỏi local storage sau khoảng thời gian còn lại này
      setTimeout(() => {
        localStorage.removeItem("shopName");
        localStorage.removeItem("shopNameExpiry");
      }, shopNameRemaingTime);
    }
  }, []);

  const {
    data: authCode,
    setData: setAuthCode,
    error: voucherError,
  } = useInputCheckout((input) => input.length > 8);

  const {
    data: shopName,
    setData: setShopName,
    error: shopNameError,
  } = useInputCheckout((input) => input.length > 3);

  const {
    data: phone,
    setData: setPhone,
    error: phoneError,
  } = useInputCheckout((input) => input.length > 3 && !isNaN(input));

  // Define the sections of the wheel, red: 0%, orange: 1, yellow: 2, green: 3, blue
  const sections = [
    {
      prize: "1 chỉ vàng 9999",
      imageUrl: "/images/game/prize/dacbiet.png",
      probability: 0,
      range: [0, 0],
    },
    {
      prize: "Thẻ nạp điện thoại 10.000VND",
      imageUrl: "/images/game/prize/thenap10k.png",
      probability: 0.22,
      range: [0, 0.22],
    },
    {
      prize: "0.5 chỉ vàng 9999",
      imageUrl: "/images/game/prize/giainhat.png",
      probability: 0,
      range: [0.22, 0.22],
    },
    {
      prize: "Voucher mua hàng trị giá 500.000VND",
      imageUrl: "/images/game/prize/voucher500k.png",
      probability: 0.01,
      range: [0.22, 0.23],
    },
    {
      prize: "Sắp trúng thưởng rồi",
      imageUrl: "",
      probability: 0.22,
      range: [0.23, 0.45],
    },
    {
      prize: "1 bịch bỉm Mễ Mễ Prime/Eco",
      imageUrl: "/images/game/prize/bim.png",
      probability: 0.03,
      range: [0.45, 0.48],
    },
    {
      prize: "Thẻ nạp điện thoại 50.000VND",
      imageUrl: "/images/game/prize/thenap50k.png",
      probability: 0.09,
      range: [0.48, 0.57],
    },
    {
      prize: "Chúc bạn may mắn",
      imageUrl: "",
      probability: 0.225,
      range: [0.57, 0.795],
    },
    {
      prize: "Voucher mua hàng trị giá 1 triệu",
      imageUrl: "/images/game/prize/voucher1tr.png",
      probability: 0.005,
      range: [0.795, 0.8],
    },

    {
      prize: "Thẻ nạp điện thoại 20.000VND",
      imageUrl: "/images/game/prize/thenap20k.png",
      probability: 0.2,
      range: [0.8, 1],
    },
  ];

  // function get zalo token from database
  const getZaloToken = async () => {
    try {
      const response = await fetch(`${baseUrl}/get-zalo-token`);
      if (response.status !== 200) {
        throw new Error("Có lỗi xảy ra, vui lòng thử lại sau!");
      }
      const data = await response.json();

      const access_token = data.access_token;
      const refresh_token = data.refresh_token;
      const expiredAt = data.expiredAt;
      // check if access token is on time
      if (Date.now() < new Date(expiredAt).getTime()) {
        return access_token;
      } else {
        // check if access token is expired
        // call refresh token api zalo to get new access token and refresh token
        const response = await fetch(
          "https://oauth.zaloapp.com/v4/oa/access_token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              secret_key: "VD7O6fUV9x26HVYVR2rD",
            },
            body: new URLSearchParams({
              refresh_token,
              app_id: "2800059036509755763",
              grant_type: "refresh_token",
            }),
          }
        );
        if (response.status !== 200) {
          throw new Error(
            "Có lỗi xảy ra với hệ thống zalo, vui lòng thử lại sau!"
          );
        }
        const dataToken = await response.json();

        const newAccessToken = dataToken.access_token;

        // update new access token and refresh token to database
        const responseUpdate = await fetch(`${baseUrl}/update-zalo-token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataToken),
        });
        if (responseUpdate.status !== 200) {
          throw new Error(
            "Có lỗi xảy ra khi lưu token mới, vui lòng thử lại sau!"
          );
        }
        return newAccessToken;
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Handle the spin button click event
  const handleSpin = async () => {
    if (!isValid) {
      setIsModalOpen(true);
      setMessage("Vui lòng hoàn thiện thông tin trước khi quay!");
      return;
    }

    if (isSpinning) return; // Prevent multiple spins while one is in progress
    setIsSpinning(true);

    // Xét điều kiện trước khi quay có người tạo mã xác thực mới làm mã sắp quay thành không hợp lệ => không cho quay
    const userInfo = {
      authCode,
    };

    const response = await fetch(`${baseUrl}/check-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfo),
    });

    if (response.status === 423) {
      alert("Mã xác nhận đã hết hiệu lực, hãy tạo hoặc sử dụng mã mới!");
      setIsValid(false);
      return;
    }

    if (response.status === 422) {
      alert("Bạn đã hết số lần quay!");
      setIsValid(false);
      return;
    }

    const data = await response.json();

    // Lấy mức độ ưu tiên của dữ liệu
    const prior = data.firstVoucherNoneRoll.prior;
    const remainingMoney = data.remainingMoney;

    // thành lập mảng index của các section có giá trị thấp
    const lowPriceArrIndex = [1, 4, 6, 7, 9];
    const nonePriceArrIndex = [4, 7];
    // Check prior case

    let selectedIndex;

    // * Khống chế các điều kiện quay trúng giải
    // Set the selected section index based on the prior
    if (prior === "Ultra") {
      selectedIndex = 2;
    } else if (prior === "Top") {
      selectedIndex = 0;
    } else if (prior === "V500k") {
      selectedIndex = 3;
    } else if (prior === "V1Tr") {
      selectedIndex = 8;
    } else if (remainingMoney <= 1200000 && remainingMoney > 50000) {
      // selectedIndex sẽ chỉ rơi ngẫu nhiên vào các index có giá trị thấp được chỉ định trong array lowPriceArrIndex
      selectedIndex =
        lowPriceArrIndex[Math.floor(Math.random() * lowPriceArrIndex.length)];
    } else if (remainingMoney <= 50000) {
      // selectedIndex sẽ chỉ rơi ngẫu nhiên vào các index có giá trị thấp được chỉ định trong array nonePriceArrIndex
      selectedIndex =
        nonePriceArrIndex[Math.floor(Math.random() * nonePriceArrIndex.length)];
    } else {
      // Generate a random number between 0 and 1
      const randomValue = Math.random();

      // Calculate index of the selected section based on the random value
      selectedIndex = sections.findIndex(
        (section) =>
          randomValue >= section.range[0] && randomValue < section.range[1]
      );
    }
    // Map the selected section to its degree range
    const sectionAngle = 360 / sections.length;

    const minDegree = selectedIndex * sectionAngle;

    // Return a random degree within the selected section's range
    const extraDegree = minDegree + sectionAngle / 2;

    const totalDegree = degree + (360 - extraDegree); // Rotate so selected section aligns with the indicator

    // Apply rotation and animation
    innerWheelRef.current.style.transition =
      "transform 6s cubic-bezier(0, .99, .44, .99)";
    innerWheelRef.current.style.transform = `rotate(${totalDegree}deg)`;

    // check and get zalotoken
    const access_token = await getZaloToken();
    // Show the result only after the spin animation ends
    setTimeout(async () => {
      const userInfo = {
        authCode,
        access_token,
        shopName: shopName ? shopName : localStorage.getItem("shopName"),
        prize: sections[selectedIndex].prize,
      };

      try {
        const response = await fetch(`${baseUrl}/user-won-prize`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userInfo),
        });

        if (response.status !== 200) {
          throw new Error("Có lỗi xảy ra, vui lòng thử lại sau!");
        }

        const data = await response.json();

        // Notify the user with the result
        const resultMessage = {
          prize: sections[selectedIndex].prize,
          remainRoll: data.remainRoll,
          imageUrl: sections[selectedIndex].imageUrl,
        };

        onSpinResult(resultMessage); // Notify parent with the result
      } catch (err) {
        alert(err.message);
      }

      innerWheelRef.current.style.transition = "none";
      innerWheelRef.current.style.transform = `rotate(${
        (360 - extraDegree) % 360
      }deg)`;
      setIsSpinning(false); // Mark spinning as complete
    }, 6200);
  };

  // Get the verification code
  const handleGetCode = async () => {
    // Ban đầu kiểm tra thời hạn chương trình
    if (
      new Date() > new Date("2025-03-08T16:59:00.000+00:00") ||
      new Date() < new Date("2025-02-28T16:59:00.000+00:00")
    ) {
      setMessage("Chương trình diễn ra từ 01/03/2025 đến 08/03/2025!");
      setIsModalOpen(true);
      return;
    }
    // Kiểm tra điều kiện nhập vào
    if (!phone || !shopName) {
      setMessage("Bạn hãy điền thông tin của mình đã nhé!");
      setIsModalOpen(true);
      return;
    } else {
      setLoading(true);
      setIsModalOpen(true);
      const access_token = await getZaloToken();
      const userInfo = {
        phone,
        access_token,
      };

      try {
        const response = await fetch(`${baseUrl}/get-auth-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userInfo),
        });

        if (response.status === 404) {
          throw new Error("Số điện thoại không tồn tại!");
        }

        if (response.status === 422) {
          throw new Error("Ban đã hết số lần quay!");
        }

        if (response.status !== 200) {
          throw new Error("Có lỗi xảy ra, vui lòng thử lại sau!");
        }

        setLoading(false);
        setIsSpinning(false); // ensure isSpining is false before spin
        setMessage("Mã xác nhận đã được gửi tới điện thoại của bạn!");

        // Thiết lập thời gian xóa shopName khỏi storage sau 5 phút
        const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
        // save shopName and expiry time to localStorage
        localStorage.setItem("shopName", shopName);
        localStorage.setItem("shopNameExpiry", Date.now() + fiveMinutes);
        setTimeout(() => {
          if (localStorage.getItem("shopName")) {
            localStorage.removeItem("shopName");
          }
        }, fiveMinutes);
      } catch (err) {
        setLoading(false);
        setMessage(err.message);
      }
    }
  };

  const handleSubmit = async () => {
    if (!authCode) {
      setMessage("Vui lòng điền mã xác nhận!");
      setIsModalOpen(true);
      return;
    } else {
      setLoading(true);
      setIsModalOpen(true);
      const userInfo = {
        authCode,
      };

      try {
        const response = await fetch(`${baseUrl}/check-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userInfo),
        });

        if (response.status === 404) {
          throw new Error("Mã xác nhận không tồn tại!");
        }
        if (response.status === 422) {
          throw new Error("Bạn đã hết số lần quay!");
        }
        if (response.status === 423) {
          throw new Error(
            "Mã xác nhận đã hết hiệu lực, hãy tạo hoặc sử dụng mã mới!"
          );
        }
        if (response.status !== 200) {
          throw new Error("Có lỗi xảy ra, vui lòng thử lại sau!");
        }
        const data = await response.json();
        setIsValid(true);
        setLoading(false);
        setIsSpinning(false); // ensure isSpining is false before spin
        setMessage(data.message);
      } catch (err) {
        setLoading(false);

        setMessage(err.message);
      }
    }
  };

  const closeModalHandle = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <ModalCheck
          loading={loading}
          message={message}
          onCloseModal={closeModalHandle}
        />
      )}

      <div
        className="text-center"
        style={{ maxWidth: "700px", margin: "0 auto" }}
      >
        <img
          src="/images/game/ribbonlogo.png"
          alt="ribbon_logo"
          className="w-100 vibratelogo"
        />
      </div>

      <div className="row p-2" style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div className="col-12 col-md-6">
          <div className="d-flex gap-1 justify-content-between mb-4">
            <div className="w-100">
              <div className="mb-2">
                <label style={{ color: "#1e9e35" }}>Điện thoại:</label>
                <input
                  className="form-control"
                  type="number"
                  name="phone"
                  value={phone}
                  placeholder="Số điện thoại."
                  onChange={(e) => setPhone(e.target.value)}
                />
                {phoneError && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Bạn hãy điền đúng số điện thoại của mình nhé.
                  </p>
                )}
              </div>

              <div>
                <label style={{ color: "#1e9e35" }}>Tên shop:</label>
                <input
                  className="form-control"
                  type="text"
                  name="shopName"
                  value={shopName}
                  placeholder="Tên cửa hàng!"
                  onChange={(e) => setShopName(e.target.value)}
                />
                {shopNameError && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Bạn hãy điền đúng tên shop mình vào đây nhé.
                  </p>
                )}
              </div>
            </div>

            <button
              type="button"
              className="btn btn-primary mt-5 mb-5"
              onClick={handleGetCode}
              style={{ fontSize: "12px" }}
            >
              Lấy mã xác nhận
            </button>
          </div>

          <div>
            <label style={{ color: "#1e9e35" }}>Mã xác nhận:</label>
            <input
              className="form-control"
              type="text"
              name="authCode"
              value={authCode}
              placeholder="Mã xác nhận."
              onChange={(e) => setAuthCode(e.target.value)}
            />
            {voucherError && (
              <p style={{ color: "red", fontSize: "12px" }}>
                Bạn hãy điền chính xác mã xác nhận được cấp bởi Mễ Mễ nhé!
              </p>
            )}
          </div>

          <div className="text-center">
            <button onClick={handleSubmit} className="btn btn-danger mt-3 mb-3">
              Kiểm tra thông tin
            </button>
          </div>
        </div>

        <div id="wheel" className="col-12 col-md-6">
          <div id="inner-wheel" ref={innerWheelRef}>
            <span className="red">1 chỉ vàng 9999</span>
            <span className="orange text-primary">Thẻ nạp 10k</span>
            <span className="yellow text-danger">0.5 chỉ vàng 9999</span>
            <span className="green">Voucher 500k</span>
            <span className="blue">Sắp trúng thưởng rồi</span>
            <span style={{ width: "90px" }} className="purple">
              1 bịch Mễ Mễ Prime/Eco
            </span>
            <span className="cyan text-danger">Thẻ nạp 50k</span>
            <span className="light-blue">Chúc bạn may mắn</span>
            <span className="light-purple">Voucher 1 triệu</span>
            <span className="pink text-muted">Thẻ nạp 20k</span>
          </div>
          <div id="spin" onClick={handleSpin}>
            <div id="inner-spin"></div>
          </div>
          <div id="indicator"></div> {/* Static Indicator */}
        </div>
      </div>

      <div className="text-start ms-5">
        <img
          src="/images/game/20k.png"
          alt="ribbon"
          style={{ maxWidth: "70px" }}
          data-aos="fade-right"
          className="vibrate"
        />
      </div>

      <div className="text-end me-5">
        <img
          src="/images/game/50k.png"
          alt="ribbon"
          style={{ maxWidth: "70px" }}
          data-aos="fade-left"
          className="vibrate"
        />
      </div>

      <div data-aos="fade-up" className="text-center">
        <img
          src="/images/game/ribbon.png"
          alt="ribbon"
          className="w-100 vibratelogo"
          style={{ maxWidth: "550px" }}
        />
      </div>

      <div className="text-center">
        <img
          src="/images/game/10k.png"
          alt="ribbon"
          style={{ maxWidth: "60px" }}
          data-aos="fade-up"
          className="vibrate"
        />
      </div>

      <div
        className="row text-center"
        style={{ maxWidth: "1000px", margin: "0 auto" }}
      >
        <div data-aos="fade-right" className="col-12 col-sm-6">
          <img
            src="/images/game/db.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "500px" }}
          />
        </div>

        <div data-aos="fade-left" className="col-12 col-sm-6">
          <img
            src="/images/game/nhat.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "500px" }}
          />
        </div>
      </div>

      <div
        className="row text-center"
        style={{ maxWidth: "1000px", margin: "0 auto" }}
      >
        <div data-aos="fade-up" className="col-12 col-sm-6">
          <img
            src="/images/game/nhi.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "300px" }}
          />
        </div>

        <div data-aos="fade-up" className="col-12 col-sm-6">
          <img
            src="/images/game/ba.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "300px" }}
          />
        </div>
      </div>

      <div
        className="row text-center"
        style={{ maxWidth: "1000px", margin: "0 auto" }}
      >
        <div data-aos="zoom-in" className="col-12 col-sm-6">
          <img
            src="/images/game/tu.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "400px" }}
          />
        </div>

        <div data-aos="zoom-out" className="col-12 col-sm-6">
          <img
            src="/images/game/mayman.png"
            alt="gdb"
            className="w-100"
            style={{ maxWidth: "400px" }}
          />
        </div>
      </div>

      <div data-aos="fade-up" className="text-center">
        <img
          src="/images/game/guide.png"
          alt="ribbon"
          className="w-100"
          style={{ maxWidth: "700px" }}
        />
      </div>
    </>
  );
};

export default Wheel;
